// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const PaperAirplaneIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "PaperAirplane/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.895 2.553a1 1 0 0 0-1.79 0l-7 14a1 1 0 0 0 1.17 1.409l5-1.429A1 1 0 0 0 9 15.571V11a1 1 0 0 1 2 0v4.571a1 1 0 0 0 .725.962l5 1.428a1 1 0 0 0 1.17-1.408l-7-14Z"
}));
export default PaperAirplaneIcon;